import { useEffect, useCallback, useRef } from 'react';

const STRANDS_API_URL = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

/**
 * Hook para trackear actividad del usuario.
 * Fire-and-forget: no bloquea ni espera respuesta.
 *
 * @param {string} username - Nombre del usuario
 * @param {string} module - Módulo actual (chat, price_monitor, media_monitoring, etc.)
 */
const useActivityTracker = (username, module) => {
  const lastTrackedRef = useRef('');

  // Trackear page_view automáticamente al montar o cambiar de módulo
  useEffect(() => {
    if (!username || !module) return;

    // Evitar duplicados si el módulo no cambió
    const key = `${username}:${module}`;
    if (lastTrackedRef.current === key) return;
    lastTrackedRef.current = key;

    // Fire-and-forget
    fetch(`${STRANDS_API_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, module, action: 'page_view' }),
    }).catch(() => {}); // Ignorar errores silenciosamente
  }, [username, module]);

  // Función para trackear acciones manuales (send_query, upload_file, etc.)
  const trackAction = useCallback((action, metadata = null) => {
    if (!username || !module) return;

    fetch(`${STRANDS_API_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, module, action, metadata }),
    }).catch(() => {});
  }, [username, module]);

  return { trackAction };
};

export default useActivityTracker;
